module.exports = __webpack_public_path__ + "static/media/makeup (6).740d4d70.jpg";